export const Notification = {
    path: '/notifications',
    name: 'notifications',
    component: () => import('@/views/Notification/NotificationPage.vue'),
    children: [
        {
            path: '/notifications/workers/view/:id',
            name: 'notifications.workers.view',
            component: () => import('@/views/Worker/Form/WorkerForm.vue'),
            props: {viewAction: true}
        },
        {
            path: '/notifications/contrats/view/:id',
            name: 'notifications.contrats.view',
            component: () => import('@/views/Contrat/Form/ContratForm.vue'),
            props: { viewAction: true }
        },
    ]
}